import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUp: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm5 12 7-7 7 7' }],
    ['path', { d: 'M12 19V5' }],
  ],
];

export default ArrowUp;
